export function phoneValidator($el, required) {
  if (!$el.val()) {
    return true;
  }
  const pattern = /^(?:\+\d[\d ]{0,13}|\d[\d ]{0,14})$/;
  return pattern.test($el.val());
}
Foundation.Abide.defaults.validators["phone"] = phoneValidator;
